import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { MatSort, Sort } from "@angular/material/sort";
import { Store } from '@ngrx/store';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Closures, ClosuresFilters } from '../../../commons/models/closures';

export type ClosuresColumns = ["closure_date", "tenant", "actions"];

@Component({
    selector: 'app-closures-list',
    templateUrl: './closures-list.component.html',
    styleUrls: ['./closures-list.component.scss']
})
export class ClosuresListComponent {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    //constructor(private store$: Store) {}
    pageSizeOptions = PAGE_SIZE_OPTIONS;
    //expandedElement: Closures | null;

    @Input() closures: Closures

    @Input() selectedClosure: Closures[];
    
    @Input() defaultFilters: ClosuresFilters;

    @Input() total: Observable<number>;

    @Input()
    displayedColumns: string[] = ["closure_date", "actions"];

    @Input() canAdd: boolean;
    @Input() canEdit: boolean;
    @Input() canSelect: boolean;

    @Output()
    onLoad: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
    @Output()
    onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
    @Output()
    onFilterChange: EventEmitter<ClosuresFilters> = new EventEmitter<ClosuresFilters>();

    @Output()
    onSelectClosures : EventEmitter<Closures> = new EventEmitter<Closures>();
    @Output()
    onAddClosures: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onEditClosures: EventEmitter<Closures> = new EventEmitter<Closures>();
    @Output()
    onShowClosures: EventEmitter<Closures> = new EventEmitter<Closures>();
    @Output()
    onAddSelectedClosure: EventEmitter<Closures> = new EventEmitter<Closures>();
    @Output()
    onRemoveSelectedClosure: EventEmitter<Closures> = new EventEmitter<Closures>();
    
    get selectedItems(): boolean {
      return this.selectedClosure.length > 0;
    }

    ngAfterViewInit() {
      if (this.sort) {
        this.sort.sortChange.subscribe((sort) => {
          this.onSortChange.emit(sort);
        });
      }
  
      if (this.paginator) {
        this.paginator.page.subscribe((pageEvent) => {
          this.onPageChange.emit(pageEvent);
        });
      }
    }

    addClosure() {
      this.onAddClosures.emit();
    }
 
    editClosure(closures: Closures) {
        this.onEditClosures.emit(closures);
    }
    
    selectClosure(closures: Closures) {
      this.onSelectClosures.emit(closures);
    }

    removeSelectedClosure(closures: Closures) {
      this.onRemoveSelectedClosure.emit(closures)
    }

    onFilter(filters: ClosuresFilters) {
      this.paginator.firstPage();
      this.onFilterChange.emit(filters);
    }

    showClosure(closure: Closures) {
      this.onShowClosures.emit(closure);
    }

}
